import type { AccountingSummary } from "@/utils/accounting";
import { formatCOP } from "@/utils/format";

const CapitalProjection = ({ summary }: { summary: AccountingSummary }) => {
  const rows = [
    { label: "Capital invertido (costo)", value: summary.capitalCost, tone: "text-foreground-950" },
    { label: "Inventario a precio público", value: summary.inventoryPublicValue, tone: "text-foreground-800" },
    { label: "Consignado a asesores", value: summary.consignedToAdvisors, tone: "text-secondary-200" },
  ];

  const total = Math.max(1, summary.projectionDirect + summary.projectionConsigned);
  const directPct = (summary.projectionDirect / total) * 100;
  const consignedPct = (summary.projectionConsigned / total) * 100;

  return (
    <div className="glass-panel rounded-lg p-4 md:p-5">
      <div className="flex items-center gap-2 mb-1">
        <span className="w-8 h-8 rounded-md bg-primary-500/25 text-primary-100 flex items-center justify-center">
          <i className="ri-funds-box-line" />
        </span>
        <h3 className="editable-title text-base font-bold">Capital y proyección de ganancia</h3>
      </div>
      <p className="text-[11px] text-foreground-500 mb-4">
        Vender en punto o internet rinde más que venderle al asesor.
      </p>

      <div className="space-y-2">
        {rows.map((r) => (
          <div
            key={r.label}
            className="flex items-center justify-between rounded-md bg-background-200/40 border border-background-300/40 px-3 py-2"
          >
            <span className="text-xs text-foreground-600">{r.label}</span>
            <span className={`text-sm font-bold ${r.tone}`}>{formatCOP(r.value)}</span>
          </div>
        ))}
      </div>

      <div className="mt-4 rounded-md bg-background-200/40 border border-accent-500/20 px-3 py-3">
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-600">Proyección de ganancia</span>
          <span className="text-base font-heading font-extrabold text-accent-200">
            {formatCOP(summary.projectedProfit)}
          </span>
        </div>
        <div className="h-2 rounded-full bg-background-300/40 overflow-hidden mt-3 flex">
          <div className="h-full bg-gradient-to-r from-primary-400 to-primary-500" style={{ width: `${directPct}%` }} />
          <div className="h-full bg-gradient-to-r from-secondary-400 to-secondary-500" style={{ width: `${consignedPct}%` }} />
        </div>
        <div className="flex items-center justify-between mt-2 text-[10px] text-foreground-500">
          <span>
            <i className="ri-store-2-line text-primary-200" /> Punto / internet · {formatCOP(summary.projectionDirect)}
          </span>
          <span>
            <i className="ri-hand-heart-line text-secondary-200" /> Venta a asesor · {formatCOP(summary.projectionConsigned)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CapitalProjection;